import { AuthService } from "./../../shared/models/auth.service";
import { Injectable, Inject } from "@angular/core";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { WeGoConfig, IAPIResponse, DataListModel } from "../../shared/config";
import {
  OrganizationDriverMappingModel,
  OrganizationDriverPersonModel
} from "./organization-driver.model";
import { OrganizationDriverInvitationModel } from "../../admin-invite-popup/models/admin-to-invite.model";

@Injectable()
export class OrganizationDriverService {
  constructor(private authService: AuthService, private http: Http) {}

  public GetDriverListByOrganizationHashId(
    organizationHashId: string,
    input?: DataListModel
  ): Observable<IAPIResponse> {
    let getDriverListForOrganization =
      WeGoConfig.API_GET_DRIVER_LIST_FOR_ORGANIZATION;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getDriverListForOrganization =
        getDriverListForOrganization +
        "?" +
        queryString +
        "&organizationHashId=" +
        organizationHashId;
    } else {
      getDriverListForOrganization =
        getDriverListForOrganization +
        "?organizationHashId=" +
        organizationHashId;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getDriverListForOrganization, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetDriverListByOrganizationToInstance(
    organizationHashId: string,
    input?: DataListModel
  ): Observable<IAPIResponse> {
    let getDriverListForOrganization =
      WeGoConfig.API_GET_DRIVER_LIST_FOR_ORGANIZATION_TO_INSTANCE;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getDriverListForOrganization =
        getDriverListForOrganization +
        "?" +
        queryString +
        "&organizationHashId=" +
        organizationHashId;
    } else {
      getDriverListForOrganization =
        getDriverListForOrganization +
        "?organizationHashId=" +
        organizationHashId;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getDriverListForOrganization, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public AssignDriverToOrganization(
    organizationDriverMappingModel: OrganizationDriverMappingModel
  ): Observable<IAPIResponse> {
    let body = organizationDriverMappingModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(WeGoConfig.API_POST_ORGANIZATION_DRIVER_DETAIL, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportDriverList(
    organizationHashId: string,
    input?: DataListModel
  ): any {
    input.currentPage = 0;
    let getDriverUrl = WeGoConfig.API_EXPORT_ORGANIZATION_MAP_DRIVER_LIST;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getDriverUrl =
        getDriverUrl +
        "?" +
        queryString +
        "&organizationHashId=" +
        organizationHashId;
    } else {
      getDriverUrl = getDriverUrl + "?organizationHashId=" + organizationHashId;
    }

    let headers = this.authService.GetHeader("text/csv");
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getDriverUrl, options);
  }

  public DeleteDriverMapping(
    organizationToDriverMapHashId: string
  ): Observable<IAPIResponse> {
    let getDriverToOrganizationUrl =
      WeGoConfig.API_DELETE_ORGANIZATION_DRIVER_MAPPING +
      "?organizationToDriverMapHashId=" +
      organizationToDriverMapHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(getDriverToOrganizationUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public AddPerson(
    driverPersonModel: OrganizationDriverPersonModel
  ): Observable<IAPIResponse> {
    let body = driverPersonModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(
        WeGoConfig.API_POST_ORGANIZATION_DRIVER_PERSON_DETAIL,
        body,
        options
      )
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetPersonListToInvite(
    organizationHashID: string,
    emailAddress: string
  ): Observable<IAPIResponse> {
    let getOrganizationDriverUrl =
      WeGoConfig.API_GET_ORGANIZATION_PERSON_TO_INVITE_AS_DRIVER_LIST;

    getOrganizationDriverUrl =
      getOrganizationDriverUrl +
      "?organizationHashID=" +
      organizationHashID +
      "&emailAddress=" +
      emailAddress;

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getOrganizationDriverUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public InviteAdminOfOrganization(
    organizationDriverInvitationModel: OrganizationDriverInvitationModel
  ): Observable<IAPIResponse> {
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    let urlInviteDriverOfOrganization =
      WeGoConfig.API_POST_INVITE_DRIVER_OF_ORGANIZATION;

    return this.http
      .post(
        urlInviteDriverOfOrganization,
        organizationDriverInvitationModel,
        options
      )
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetOrganizationBasedDriverList(
    input?: DataListModel,
    customerHashId: string = "",
    instanceHashId: string = "",
    companyHashId: string = "",
    organizationHashId: string = "",
    pageName: string = ""
  ): Observable<IAPIResponse> {
    let getDriverListUrl: string;

    switch (pageName) {
      case "Cost_Center_Report":
        getDriverListUrl =
          WeGoConfig.API_GET_DRIVER_LIST_FOR_COST_CENTER_REPORT;
        break;

      default:
        getDriverListUrl =
          WeGoConfig.API_GET_DRIVER_LIST_FOR_COST_CENTER_REPORT;
        break;
    }

    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getDriverListUrl =
        getDriverListUrl +
        "?" +
        queryString +
        "&customerHashId=" +
        customerHashId +
        "&instanceHashId=" +
        instanceHashId +
        "&companyHashId=" +
        companyHashId +
        "&organizationHashId=" +
        organizationHashId;
    } else {
      getDriverListUrl =
        getDriverListUrl +
        "?customerHashId=" +
        customerHashId +
        "&instanceHashId=" +
        instanceHashId +
        "&companyHashId=" +
        companyHashId +
        "&organizationHashId=" +
        organizationHashId;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getDriverListUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/organizationdriver/models/organization-driver.service.ts